import CorporateScheduleCalculator from '../../../../controls/dateControls/CorporateScheduleCalculator'
import DateSelector from '../../../../controls/dateControls/DateSelector'
import TemplateView from '../../../../TemplateView'
import {getInstance as getModalAlert} from '../../UserPanelModalAlert'
import messageResource from '../../../../messageResource'
import {ModalAlertPointerPosition} from '../../../../components/modalAlert/constants'
import {ValidationErrors} from '../../constants'

export default class EffectiveDateCell extends TemplateView {
    constructor({
        dateFromLabel,
        readOnly,
        scrollTo,
        onChangeCb = () => {},
        rollbackChanges = () => {},
        subscribeSelectorOnScroll = () => {},
    }) {
        super()

        this.params = {
            dateFromLabel,
            scrollTo,
            readOnly,
        }

        this.callbacks = {
            onChangeCb,
            rollbackChanges,
            subscribeSelectorOnScroll,
        }

        this.state = {
            invertedDays: {},
            weekStartDay: 0,
            defaultWorkSchedule: [],
            date: null,
            effective: false,
            needShowWarning: false,
            error: null,
        }

        this.onStateChanged(() => this._update())

        this.onStatePropertyChanged('error', error => this._updateError(error))
        this.onStatePropertyBecameTrue('needShowWarning', () => this._showDuplicateWarning())
    }

    templateHtml() {
        return '<div class="effectiveDateCellContent">' +
               '    <div class="dateSelectorPlaceholder">' +
               '        <div class="dateFromLabel"><%=dateFromLabel%></div>' +
               '        <div class="dateSelector"/>' +
               '        <div class="dateLabel"></div>' +
               '    </div>' +
               '    <div class="currentLabel"><%=currentLabel%></div>' +
               '</div>'
    }

    templateModel() {
        return {
            dateFromLabel: this.params.dateFromLabel
        }
    }

    messageKeys() {
        return {
            currentLabel: 'user.add_edit.js.wd_editor.working_schedule_current'
        }
    }

    afterRender() {
        this.$dateSelector = this.find('.dateSelector')
        this.$currentLabel = this.find('.currentLabel')
        this.$dateLabel = this.find('.dateLabel')
    }

    hideSelector() {
        this.dateSelector.hideMenuOnScrollOrResize()
    }

    _update() {
        this.$currentLabel.toggle(this.state.effective)

        this.$dateSelector.empty()

        this.$dateLabel.toggle(this.params.readOnly)

        const date = this.state.date ? this.state.date.parseJSONDate() : null
        const format = Date.convertSmartToExtDateFormat(window.SystemSettings.dateFormat).replace(/F/, "M")

        if (this.params.readOnly) {
            if (!!date)
                this.$dateLabel.text(date.format(format))
            return
        }

        const scheduleCalculator = new CorporateScheduleCalculator().init(this.state.invertedDays, this.state.defaultWorkSchedule)

        this.dateSelector = new DateSelector({
            minValue: new Date(1970, 0, 1),
            weekStartDay: this.state.weekStartDay - 1,
            renderTo: this.$dateSelector[0],
            scheduleCalculator: scheduleCalculator,
            date: date,
            format: format,
            menuAlign: 'bl-tl',
        })

        this.dateSelector.on("change", () => this.callbacks.onChangeCb(this.dateSelector.getValue().toJSON()))

        let _setCellClasses = this.dateSelector.menu.picker.setCellClasses
        this.dateSelector.menu.picker.setCellClasses = function() {
            // proxy method
            // ugly hack for prevent focusing on element after picker opens.
            // Focus on element move it to top bypassing customScroll
            this.suppressActiveDayFocus = true
            _setCellClasses.apply(this, arguments)
        }
    }

    _updateError(error) {
        this.getEl().toggleClass('invalid', error !== null)

        if (error === ValidationErrors.DUPLICATED_EFFECTIVE_DATE)
            this.$dateSelector.attr('title', messageResource.getMessage('rates.errors.duplicate_date'))
    }

    _showDuplicateWarning() {
        const msg =
            messageResource.getMessage('rates.editor.work_schedule.duplicate_date') + '\n' +
            messageResource.getMessage('rates.editor.modifications_will_be_discarded')

        this.params.scrollTo(this.$dateSelector)

        getModalAlert().setState({
            text: msg,
            pointerPosition: ModalAlertPointerPosition.LEFT
        }).showAt(this.$dateSelector, () => {
            this.callbacks.rollbackChanges()
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/workSchedule/EffectiveDateCell.js